import TopNav from '@/components/TopNav';
import Footer from '@/components/Footer';
import { useAuth } from '@/contexts/AuthContext';

const PrivacyPolicy = () => {
  const { user, signOut } = useAuth();

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <TopNav user={user} onLogout={signOut} />
      <main className="flex-1 container mx-auto max-w-3xl px-4 py-10 sm:py-14">
        <h1 className="text-3xl sm:text-4xl font-bold mb-2">Privacy Policy</h1>
        <p className="text-sm text-muted-foreground mb-8">Last updated: March 28, 2026</p>

        <div className="space-y-8 text-[15px] leading-relaxed text-foreground/90">
          <section>
            <h2 className="text-xl font-semibold mb-2">1. Introduction</h2>
            <p>Welcome to IgniteAiTool. Your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your information when you use our translation service at translator.aiapps.tools.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">2. What Data We Collect</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li><strong>Account information:</strong> Email address, display name, and password when you create an account.</li>
              <li><strong>Translation input:</strong> Text or images you submit for translation.</li>
              <li><strong>Usage data:</strong> Number of translations performed, preferred languages, and feature usage.</li>
              <li><strong>Device information:</strong> Browser type, device fingerprint (for trial abuse prevention), and IP address.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">3. How We Use Your Data</h2>
            <ul className="list-disc pl-6 space-y-1">
              <li>To provide and improve the translation service.</li>
              <li>To manage your account and subscription status.</li>
              <li>To enforce usage limits and prevent abuse of the free trial.</li>
              <li>To respond to support requests.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">4. Data Protection &amp; Storage</h2>
            <p><strong>We do not store or share your translation data.</strong> Text submitted for translation is processed in real time and is not persisted beyond what is necessary to deliver the result. Translation history is stored only for logged-in users who opt into the feature and can be deleted at any time.</p>
            <p className="mt-2">We use industry-standard security measures, including encrypted connections (HTTPS), row-level security on our database, and secure authentication protocols.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">5. Cookies &amp; Tracking</h2>
            <p>We use essential cookies to manage your authentication session. We do not use third-party advertising trackers. Device fingerprinting is used solely to enforce free trial limits and prevent abuse.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">6. Third-Party Services</h2>
            <p>We use third-party services for payment processing (Stripe) and AI-powered translation. These providers have their own privacy policies and handle data in accordance with their respective terms.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">7. Your Rights</h2>
            <p>You may request access to, correction of, or deletion of your personal data at any time by contacting us.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold mb-2">8. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at{' '}
              <a href="mailto:ansontansv@gmail.com" className="text-primary hover:underline">ansontansv@gmail.com</a>.
            </p>
          </section>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
